import script from "./existingPatient.vue?vue&type=script&setup=true&lang=js"
export * from "./existingPatient.vue?vue&type=script&setup=true&lang=js"

import "./existingPatient.vue?vue&type=style&index=0&id=94444e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94444e14"]])

export default __exports__